import type { SignalsApiStatusResponse } from "app/pages/sales-intelligence/sub-modules/management/types";

export const resolveSignalsApiCustomAttributes = (dataStatuses?: SignalsApiStatusResponse): Record<string, number> => {
    return {
        ["number API subscribed domains"]: dataStatuses?.subscribedDomainsCount ?? 0,
        ["number API signals"]: dataStatuses?.signalsCount ?? 0,
        ["number webhooks"]: dataStatuses?.webhooksCount ?? 0,
    };
};
